import { render, staticRenderFns } from "./ActiveEnrollmentCard.vue?vue&type=template&id=652ed65b&scoped=true&"
import script from "./ActiveEnrollmentCard.vue?vue&type=script&lang=js&"
export * from "./ActiveEnrollmentCard.vue?vue&type=script&lang=js&"
import style0 from "./ActiveEnrollmentCard.vue?vue&type=style&index=0&id=652ed65b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652ed65b",
  null
  
)

export default component.exports